import React, { useState } from 'react';
import { Button } from '@mui/material';
import './AssignFeature.css'; // Ensure the CSS is loaded

const AssignFeature = ({
  selectedRows,
  toggleAssign,
  isAssignOpen,
  reviewers,
  activeReviewToken,
  assignApplication
}) => {
  
  const [selectedReviewers, setSelectedReviewers] = useState([]);
  console.log("reviewers", reviewers);
  console.log("activeReviewToken", activeReviewToken);

  const handleCheckboxChange = (reviewerId) => {
    if (selectedReviewers.includes(reviewerId)) {
      setSelectedReviewers(selectedReviewers.filter(id => id !== reviewerId));
    } else {
      setSelectedReviewers([...selectedReviewers, reviewerId]);
    }
  };

  // Sort reviewers alphabetically by familyName, then by firstName
  const sortedReviewers = [...reviewers]
  .filter(reviewer => reviewer.tokens.includes(activeReviewToken))
  .sort((a, b) => {
    if (a.familyName < b.familyName) return -1;
    if (a.familyName > b.familyName) return 1;
    if (a.givenName < b.givenName) return -1;
    if (a.givenName > b.givenName) return 1;
    return 0;
  });

  const handleAssign = () => {
    assignApplication(selectedReviewers); // Pass selected reviewers to parent
  };

  return (
    <>
      {/* Assign feature container */}
      <div className="assign-feature-container">
        {isAssignOpen && (
          <div>
            <div className="scrollable-table">
              <table>
                <tbody>
                  {sortedReviewers.map((reviewer, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="checkbox"
                          id={reviewer.id}
                          name={reviewer.id}
                          checked={selectedReviewers.includes(reviewer.id)}
                          onChange={() => handleCheckboxChange(reviewer.id)}
                        />
                      </td>
                      <td>
                        <label>
                          {reviewer.familyName}, {reviewer.givenName}
                        </label>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="button-group">
              {/* Assign for Review button */}
              <button className="button-assign" onClick={handleAssign}>
                {`Assign ${selectedRows.length} submission${selectedRows.length > 1 ? "s" : ""} to ${selectedReviewers.length} reviewer${selectedReviewers.length > 1 ? "s" : ""}`}
              </button>

              {/* Close button */}
              <div className="button-close" onClick={toggleAssign}>
                &times; {/* This is the 'X' */}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AssignFeature;
